export default "<p>categoria-blog works!</p>\n"